import prepareTranslate from '@/helpers/dictionary';
import {
  Button, Card, Center, Text,
} from '@mantine/core';
// import { DatePickerInput } from '@mantine/dates';
import PropTypes from 'prop-types';

const Footer = (props) => {
  const t = prepareTranslate();
  const {
    totalAmount,
    label,
    handleSendEmail,
    isAllAgents,
    handleDownloadSummary,
    isDataLoading,
    hasSelectedRows,
  } = props;

  return (
<>
  <Card p='0.5rem' bg='var(--mantine-color-secondary-0)' w='15rem'>
      <Center>
        <Text c='white' fw={700}>
          {label.replace('{0}', totalAmount.toLocaleString())}
        </Text>
      </Center>
  </Card>
      {/* a dateInput of pay date */}

        {/* <Card p={'1rem'} bg={'white'} mt='md'>
            <DatePickerInput
                label= {t('pages.monthlyPayment.dateInputLabel')}
                required
                value={paymentDate ? new Date(paymentDate) : null}
                onChange={(date) => {
                  setPaymentDate(date ? date.toISOString() : '');
                  setDateError('');
                }}
                w={'15rem'}
                error={dateError}
              />
        </Card> */}

        {isAllAgents ? (
          <Button onClick={handleDownloadSummary} mt='md' disabled={isDataLoading}>
            {t('pages.monthlyPayment.viewSummary')}
          </Button>
        ) : (
          <Button onClick={handleSendEmail} mt='md' disabled={!hasSelectedRows}>
            {t('pages.monthlyPayment.sendEmail')}
          </Button>
        )}
      </>
  );
};

Footer.propTypes = {
  totalAmount: PropTypes.number,
  label: PropTypes.string,
  handleSendEmail: PropTypes.func,
  isAllAgents: PropTypes.bool,
  handleDownloadSummary: PropTypes.func,
  isDataLoading: PropTypes.bool,
  hasSelectedRows: PropTypes.bool,
};
export default Footer;
